import { getOrCreateAnonymousId } from "./shareTracker";
import { createSalesAttributionClient } from "./salesAttributionPending";
import { joinSalesHandoffState, splitSalesHandoffState, SALES_HANDOFF_STATE_KEY } from "./salesHandoffState";

const client = createSalesAttributionClient(getOrCreateAnonymousId);

export const bindSalesAttribution = client.bind;

export function bindCurrentSalesAttribution() {
  try {
    return client.initialize(window.localStorage.getItem("naezip_to_ac_se"));
  } catch {
    return Promise.resolve(false);
  }
}

/** 카카오 authorize state 에 살아있는 영업 핸드오프 토큰을 붙인다(없으면 원문). */
export function withSalesHandoffState(state) {
  // 콜백 state 가 그대로 재진입해도(|sa= 포함) 접미를 두 번 붙이지 않는다.
  return joinSalesHandoffState(splitSalesHandoffState(state).state, client.pendingHandoffToken());
}

/**
 * authorize URL 을 문자열 결합으로 만드는 진입점용(state 를 encodeURIComponent 하지 않는 곳).
 * 이미 조립된 `&state=<값>` 바로 뒤에 붙인다. 토큰이 없으면 빈 문자열이라 기존 URL 이 그대로다.
 */
export function salesHandoffStateSuffix() {
  const token = client.pendingHandoffToken();
  return token ? `%7C${SALES_HANDOFF_STATE_KEY}%3D${token}` : "";
}

/** state 없이 authorize 하던 진입점용 — 토큰이 있을 때만 `&state=|sa=<token>` 을 통째로 붙인다. */
export function salesHandoffStateQuery() {
  const suffix = salesHandoffStateSuffix();
  return suffix ? `&state=${suffix}` : "";
}

/** 콜백 브라우저에 pending 이 없어도 state 토큰으로 복원해 로그인 직후 bind 가 실리게 한다. */
export function importSalesHandoff(token) {
  return client.importHandoff(token);
}

export { splitSalesHandoffState };
